export const BagDetailsForm = {
    title: 'Bag details',
    display: 'Bag',
    key: [],
    sections: [
      {
        columns: 2,
        fields: [
          {
            label: 'Comment',
            type: 'text',
            key: ['comment'],
            pos: {
              col: 1,
              row: 3,
              size: 1,
            },
          },
        ],
      },
    ],
  };

  